/** @format */

import axios from 'axios';
import { isDev } from '../constants/url';

const API_GATEWAY = 'https://prod-api.vegapay.tech';
// const ALPHA_API_GATEWAY = 'https://api.vegapay.tech/alpha';
const ALPHA_API_GATEWAY = 'https://alpha-api.vegapay.tech';
const env = {
  alpha_gateway: '/alpha',
  prod_gateway: '',
  sandbox_gateway: '/sandbox',
};
export const API_BASE_URL = `${isDev ? ALPHA_API_GATEWAY : API_GATEWAY}`;

export const configureAxiosDefaults = () => {
  const currentHost = window.location.hostname;
  const BASE_URL = `${isDev ? ALPHA_API_GATEWAY : API_GATEWAY}`;
  console.log('BASE URL', BASE_URL);
  axios.defaults.baseURL = BASE_URL;
};

//request interceptor
axios.interceptors.request.use(
  (config: any) => {
    config.headers['Authorization'] = `${sessionStorage.getItem('token')}`;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

//response interceptor
// axios.interceptors.response.use(
//   function (response) {
//     return response;
//   },
//   function (error) {
//     if (error.response.status == 401) {
//       Auth.currentSession();
//     }
//     return Promise.reject(error);
//   }
// );
